import Joi from "joi";

const UnitSchema = Joi.object({
  unitName: Joi.string().trim().required().messages({
    "string.empty": "Unit Name is required.",
  }),
  receivingTransferApproval: Joi.string().trim().required().messages({
    "string.empty": "Receiving Transfer Approval is required.",
  }),
}).unknown(true);

export default UnitSchema;
